import { render, staticRenderFns } from "./SurveyEvent.vue?vue&type=template&id=b5637c9a"
import script from "./SurveyEvent.vue?vue&type=script&lang=js"
export * from "./SurveyEvent.vue?vue&type=script&lang=js"
import style0 from "./SurveyEvent.vue?vue&type=style&index=0&id=b5637c9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports